import React, { useEffect, useState } from "react";
import styles from "./Menu.module.css";
import Draggable from "react-draggable";

type AddLayerCompType = {
  close: any;
};

type NewItemPropType = {
  id: number;
  name: string;
  category: Array<CategoryPropType>;
};

type CategoryPropType = {
  id: number;
  title: string;
  layers: Array<LayerPropType>;
};

type LayerPropType = {
  id: number;
  img: string;
  title: string;
  description: string;
};

const AddLayerComp = ({ close }: AddLayerCompType) => {
  const LayerDetails: Array<NewItemPropType> = [
    {
      id: 1,
      name: "Item 1",
      category: [
        {
          id: 1,
          title: "Category 1",
          layers: [
            {
              id: 1,
              img: "img.jpg",
              title: "Title 1",
              description:
                "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Rerum illo eum laudantium quidem, quos a, officia animi ipsum velit aliquam ex repellendus impedit laboriosam architecto fugiat delectus itaque eligendi reprehenderit earum ratione aspernatur expedita repellat tenetur. Repudiandae illo accusantium eveniet quisquam iste dolores placeat magni sed impedit qui. Alias reiciendis provident similique, tenetur eveniet rerum, ea facilis dignissimos at quaerat obcaecati repudiandae cum ducimus sint cumque odit odio tempore itaque. Tempore sapiente explicabo esse quas cumque temporibus quam soluta neque est magnam distinctio, maiores doloribus sed sunt cupiditate harum quis fugit consequuntur obcaecati repudiandae aperiam. Delectus pariatur omnis natus tempore.",
            },
            {
              id: 2,
              img:"img.jpg",
              title: "Title 2",
              description: "Title 2 des",
            },
            {
              id: 3,
              img: "img.jpg",
              title: "Title 3",
              description: "Title 2 des",
            },
          ],
        },
        {
          id: 2,
          title: "Category 1",
          layers: [
            {
              id: 1,
              img: "img.jpg",
              title: "Title 1",
              description: "Title 1 des",
            },
            {
              id: 2,
              img:"img.jpg",
              title: "Title 2",
              description: "Title 2 des",
            },
          ],
        },
      ],
    },
    {
      id: 2,
      name: "Item 2",
      category: [
        {
          id: 1,
          title: "Category 1",
          layers: [
            {
              id: 1,
              img: "img.jpg",
              title: "Title 1",
              description: "Title 1 des",
            },
            {
              id: 2,
              img: "img.jpg",
              title: "Title 2",
              description: "Title 2 des",
            },
          ],
        },
      ],
    },
  ];

  return (

    <div className={`${styles.addNewLayer}`}>
      <div className={`${styles.mainContainer}`}>
        <div className={`${styles.titleContainer}`}>
          <span>Search / Browse</span>
          <img
            src={require("../../assets/close-white.png")}
            alt=""
            onClick={close}
            onTouchStart={close}
          />
        </div>
        <div className={`${styles.searchContainer}`}>
          <input type="text" placeholder="Search...." />
          <button>Search</button>
        </div>
        <div className={`${styles.newLayerContainer}`} id="newLayerContainer">
          {LayerDetails.map((item, index) => (
            <LayerHead id={item.id} name={item.name} category={item.category} />
          ))}
        </div>
        <div className={`${styles.layerDetailContainer}`}>
          {LayerDetails.map((item, index) =>
            item.category.map((item1, index1) =>
              item1.layers.map((item2, index2) => (
                <LayerInfo
                  id={item2.id}
                  img={item2.img}
                  title={item2.title}
                  description={item2.description}
                />
              ))
            )
          )}
        </div>
      </div>
    </div>
   
  );
};

export default AddLayerComp;

const LayerHead = ({ id, name, category }: NewItemPropType) => {
  let [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  const MenuToggle = () => {
    if (isMenuOpen === true) {
      setIsMenuOpen(false);
    } else {
      setIsMenuOpen(true);
    }
  };

  return (
    <div key={id} className={`${styles.layerHeadContainer}`}>
      <div className={`${styles.layerHeader}`} onClick={MenuToggle}  onTouchStart={MenuToggle}>
        <img
          src={
            isMenuOpen
              ? require("../../assets/drop-black.png")
              : require("../../assets/up-black.png")
          }
          alt=""
        />
        <span>{name}</span>
      </div>
      <div
        className={`${styles.layerContentContainer}`}
        style={{ display: `${isMenuOpen ? "flex" : "none"}` }}
      >
        {category.map((item, index) => (
          <LayerCategory id={item.id} title={item.title} layers={item.layers} />
        ))}
      </div>
    </div>
  );
};

const LayerCategory = ({ id, title, layers }: CategoryPropType) => {
  let [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  const MenuToggle = () => {
    if (isMenuOpen === true) {
      setIsMenuOpen(false);
    } else {
      setIsMenuOpen(true);
    }
  };

  return (
    <div key={id} className={`${styles.layerCategoryContainer}`}>
      <div className={`${styles.layerCategoryHeader}`} onClick={MenuToggle}  onTouchStart={MenuToggle}>
        <img
          src={
            isMenuOpen
              ? require("../../assets/drop-black.png")
              : require("../../assets/up-black.png")
          }
          alt=""
        />
        <span>{title}</span>
      </div>
      <div
        className={`${styles.layerCategoryContentContainer}`}
        style={{ display: `${isMenuOpen ? "flex" : "none"}` }}
      >
        {layers.map((item, index) => (
          <Layer
            id={item.id}
            img={item.img}
            title={item.title}
            description={item.description}
          />
        ))}
      </div>
    </div>
  );
};

const Layer = ({ id, img, title, description }: LayerPropType) => {
  const ShowInfo = () => {
    const container = document.getElementById("newLayerContainer");
    if (container != null) {
      container.style.display = "none";
    }

    const infoContainer = document.getElementById(
      `layerInfo${id}${title.trim()}`
    );
    if (infoContainer != null) {
      infoContainer.style.display = "grid";
    }
  };

  return (
    <div key={id} className={`${styles.layer}`}>
      <div className={`${styles.gridCell} ${styles.gridCell1}`}>
        <img src={require(`../../assets/${img}`)} alt="" />
      </div>
      <div className={`${styles.gridCell} ${styles.gridCell2}`}>
        <span className={`${styles.title}`}>{title}</span>
        <span className={`${styles.description}`}>{description}</span>
      </div>
      <div className={`${styles.gridCell} ${styles.gridCell3}`}>
        <span
          style={{
            backgroundColor: `var(--menu-main-color)`,
            color: `var(--menu-text-color)`,
          }}
        >
          GEO
        </span>
        <span
          style={{
            backgroundColor: `darkblue`,
            color: `var(--menu-text-color)`,
          }}
        >
          WMS
        </span>
      </div>
      <div className={`${styles.gridCell} ${styles.gridCell4}`}>
        <button>Add Layer +</button>
      </div>
      <div className={`${styles.gridCell} ${styles.gridCell5}`}>
        <img src={require("../../assets/info.png")} alt="" onClick={ShowInfo}  onTouchStart={ShowInfo}/>
      </div>
    </div>
  );
};

const LayerInfo = ({ id, img, title, description }: LayerPropType) => {
  const BackToList = () => {
    const container = document.getElementById("newLayerContainer");
    if (container != null) {
      container.style.display = "block";
    }

    const infoContainer = document.getElementById(
      `layerInfo${id}${title.trim()}`
    );
    if (infoContainer != null) {
      infoContainer.style.display = "none";
    }
  };
  return (
    <div
      key={id}
      className={`${styles.layerDetails}`}
      id={`layerInfo${id}${title.trim()}`}
    >
      <div className={`${styles.gridCell} ${styles.gridCell1}`}>
        <span>Layer Location Link</span>
      </div>
      <div className={`${styles.gridCell} ${styles.gridCell2}`}>
        <img src={require(`../../assets/${img}`)} alt="" />
      </div>
      <div className={`${styles.gridCell} ${styles.gridCell3}`}>
        <span className={`${styles.title}`}>{title}</span>
        <span className={`${styles.des}`}>{description}</span>
      </div>
      <div className={`${styles.gridCell} ${styles.gridCell4}`}>
        <div className={styles.btnContainer}>
          <button>Go to Product Navigator</button>
          <button>Data Store</button>
        </div>
        <div className={`${styles.textContainer}`}>
          <span>Temporal extent:</span>
          <span>Begin: 2020-09-01 00:00</span>
          <span>End: 2024-07-26 07:45</span>
        </div>
        <div className={`${styles.textContainer}`}>
          <span>Temporal extent:</span>
          <span>Begin: 2020-09-01 00:00</span>
          <span>End: 2024-07-26 07:45</span>
        </div>
      </div>
      <div className={`${styles.gridCell} ${styles.gridCell5}`}></div>
      <div className={`${styles.gridCell} ${styles.gridCell6}`}>
        <button onClick={BackToList}  onTouchStart={BackToList}>Back to List</button>
        <button>Remove -</button>
      </div>
      <div className={`${styles.gridCell} ${styles.gridCell7}`}></div>
    </div>
  );
};
